import { render, staticRenderFns } from "./featuredReviews.vue?vue&type=template&id=15857ed5"
import script from "./featuredReviews.vue?vue&type=script&lang=js"
export * from "./featuredReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports